/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SharedContactDealerWrapper_item$ref: FragmentReference;
export type SharedContactDealerWrapper_item = {|
  +seller: ?{|
    +serviceId: ?string
  |},
  +serviceId: ?string,
  +$refType: SharedContactDealerWrapper_item$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "SharedContactDealerWrapper_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    (v0/*: any*/)
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '70e31ce2cc08365ed74962bdbf7ac3e9';
module.exports = node;
